export default "__VITE_ASSET__DddeEcSH__"